// KPI Builder — the questions that do not build a query from a recipe: a funnel and a KPI built part by part.
import { buildAdvanced } from './advanced';
import { applyExtras } from './extras';
import { funnelConfig, placeholderQuery } from './funnel';
import { snapshotOf, toQueryString } from './serialize';
import { compileTemplate } from './templateKpi';
import { BuilderAnswers, BuilderConfig, BuilderOutput } from './types';

function compileFunnel(a: BuilderAnswers, code: string, chartType: string): BuilderOutput {
  const queries = [placeholderQuery(a.funnel.stages[0].label)];
  // Same keys as the live funnels, which do not carry the usual query settings.
  const config = { ...funnelConfig(a.funnel), builder: snapshotOf(a, false) } as unknown as BuilderConfig;
  return { visualizationCode: code, chartType, handlerKey: chartType, queryString: toQueryString(queries), config, queries };
}

/** The config is only what is typed in Extra settings, so a KPI read back from hand-written JSON regenerates exactly. */
function compileAdvanced(a: BuilderAnswers, code: string, chartType: string): BuilderOutput {
  const base = { builder: snapshotOf(a, false) } as unknown as BuilderConfig;
  const done = applyExtras(buildAdvanced(a), base, undefined, a.extras);
  return { visualizationCode: code, chartType, handlerKey: done.handlerKey, queryString: toQueryString(done.queries), config: done.config, queries: done.queries };
}

/** A funnel and a copied KPI keep their stored query, so only their handler and settings can be added to. */
function withConfigExtras(out: BuilderOutput, a: BuilderAnswers): BuilderOutput {
  const done = applyExtras(out.queries, out.config, out.handlerKey, { ...a.extras, filters: [] });
  return { ...out, handlerKey: done.handlerKey, config: done.config };
}

/** The questions that do not build their query from a recipe, or null for the ones that do. */
export function compileSpecial(a: BuilderAnswers, title: string, code: string, chartType: string): BuilderOutput | null {
  if (a.recipe === 'funnel') return withConfigExtras(compileFunnel(a, code, chartType), a);
  if (a.recipe === 'template') return withConfigExtras(compileTemplate(a, title, code), a);
  return a.recipe === 'advanced' ? compileAdvanced(a, code, chartType) : null;
}
